module.exports = __webpack_public_path__ + "media/images/pc/articles/report_01-17141b3b91bc64e3344060875860e33c.webp";